import React, {forwardRef} from 'react';
import type {Ref, ComponentPropsWithoutRef} from 'react';
import {isSafeUrl} from './utils';

const cleanUrl = (url?: string) => {
  if (!url) {
    return;
  }
  if (!isSafeUrl(url)) {
    return;
  }
  return url;
};

export const SafeAnchor = forwardRef(
  (props: ComponentPropsWithoutRef<'a'>, ref: Ref<HTMLAnchorElement>) => {
    return <a ref={ref} {...props} href={cleanUrl(props.href)} />;
  },
);

SafeAnchor.displayName = `SafeAnchor`;
